'use strict';
import { tns } from "tiny-slider"

document.addEventListener("DOMContentLoaded", () => {
    const sliders = [...document.querySelectorAll('.event-carousel__content')];
    if (sliders) {
        sliders.forEach((slider) => {
            tns({
                container: slider,
                slideBy: 1,
                autoplay: false,
                controls: true,
                nav: false,
                speed: 250,
                mouseDrag: true,
                gutter: 16,
                controlsText: ['', ''],
                loop: false,
                items: 1,
                onInit: function (instance) {
                    instance.nextButton.ariaLabel = "Framåt";
                    instance.prevButton.ariaLabel = "Bakåt";
                    instance.prevButton.removeAttribute('tabindex');
                    instance.nextButton.removeAttribute('tabindex');
                    instance.controlsContainer.removeAttribute('tabindex');
                },
                responsive: {
                    768: {
                        items: 2,
                        gutter: 24,
                    },
                    992: {
                        items: 3,
                        gutter: 24,
                    }
                },
                controlsContainer: slider.parentElement.querySelector('.event-carousel__controls'),
            });
        })

    }
})
